import { NavLink, Outlet } from "react-router-dom";
import { Bell, BellOff, LayoutDashboard, LogOut, Package, Receipt, Settings, Ticket, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useOrderWatcher } from "@/hooks/useOrderWatcher";

const NAV = [
  { to: "/admin", label: "Fluxo de caixa", icon: LayoutDashboard, end: true, id: "dashboard" },
  { to: "/admin/pedidos", label: "Pedidos", icon: Receipt, id: "orders" },
  { to: "/admin/produtos", label: "Produtos & Estoque", icon: Package, id: "products" },
  { to: "/admin/cupons", label: "Cupons & Parcerias", icon: Ticket, id: "coupons" },
  { to: "/admin/administradores", label: "Administradores", icon: Users, id: "admins" },
  { to: "/admin/configuracoes", label: "Loja & Impressora", icon: Settings, id: "settings" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const { ringing, silence, soundOn, toggleSound } = useOrderWatcher();

  const link = ({ isActive }) =>
    `flex items-center gap-3 whitespace-nowrap rounded-xl px-3 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-primo-500 text-white" : "text-slate-400 hover:bg-white/5 hover:text-white"}`;

  return (
    <div className="min-h-screen md:flex">
      <aside className="border-b border-white/[0.06] bg-[#141414] md:sticky md:top-0 md:h-screen md:w-64 md:shrink-0 md:border-b-0 md:border-r">
        <div className="flex items-center justify-between px-4 py-4 md:px-5 md:py-6">
          <div className="flex items-center gap-2">
            <img src="/images/logo.png" alt="Depósito do Primo" data-testid="admin-logo" className="h-10 w-auto rounded-md" />
            <p data-testid="admin-user-name" className="text-xs text-slate-500">{user?.name}</p>
          </div>
          <div className="flex items-center gap-1">
            <button data-testid="sound-toggle-button" onClick={toggleSound} title={soundOn ? "Alerta sonoro ligado" : "Alerta sonoro desligado"}
              className={`grid h-9 w-9 place-items-center rounded-lg ${soundOn ? "text-primo-400 hover:bg-white/5" : "text-slate-500 hover:bg-white/5"}`}>
              {soundOn ? <Bell className={`h-5 w-5 ${ringing ? "animate-bounce" : ""}`} /> : <BellOff className="h-5 w-5" />}
            </button>
            <button data-testid="logout-button-mobile" onClick={logout} className="text-slate-500 hover:text-red-400 md:hidden"><LogOut className="h-5 w-5" /></button>
          </div>
        </div>
        {ringing && (
          <div className="mx-4 mb-3 flex items-center justify-between gap-3 rounded-xl border border-primo-500/40 bg-primo-500/10 px-3 py-2 md:mx-5">
            <p data-testid="new-order-alert" className="text-sm font-semibold text-primo-300">Pedido novo aguardando!</p>
            <button data-testid="silence-alarm-button" onClick={silence} className="rounded-full bg-primo-500 px-3 py-1 text-xs font-bold text-white hover:bg-primo-400">Silenciar</button>
          </div>
        )}
        <nav className="no-scrollbar flex gap-1 overflow-x-auto px-3 pb-3 md:flex-col md:px-3">
          {NAV.map(({ to, label, icon: Icon, end, id }) => (
            <NavLink key={to} to={to} end={end} className={link} data-testid={`admin-nav-${id}`}>
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>
        <button data-testid="logout-button" onClick={logout} className="absolute bottom-6 left-5 hidden items-center gap-2 text-sm text-slate-500 hover:text-red-400 md:flex">
          <LogOut className="h-4 w-4" /> Sair
        </button>
      </aside>
      <main className="flex-1 min-w-0 px-4 py-6 md:px-10 md:py-10">
        <Outlet />
      </main>
    </div>
  );
}
